
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'
import { RallyRound } from '../lib/models/RallyRound'
import { Vehicle } from '../lib/models/Vehicle'

import sanitizeHtml from 'sanitize-html'
import { User } from '../lib/models/User'
import { Http } from '@/lib/utils/Http'

import BacTable from '@/components/BacTable.vue'
import BacButton from '@/components/BacButton.vue'

@Component({
  components: {
    BacLoggedInHeader,
    BacTable,
    BacButton
  }
})
export default class Points extends Vue {
  rounds: RallyRound[] = []
  rallyRoundId = -1

  teamPoints: any[] = []

  pathname = window.location.pathname;

  headers = [
    { text: 'Platz', value: 'ranking', width: 30, sortable: false },
    { text: 'Startnummer', value: 'id', width: 30, sortable: false },
    { text: 'Teamname', value: 'name', width: 80, sortable: false, sanitize: true },
    { text: 'Punkte', value: 'points', width: 80, sortable: false },
    { text: 'Teilnehmer', value: 'customersName', width: 80, sortable: false, sanitize: true },
    { text: 'Fahrzeug', value: 'vehicle', width: 80, sortable: false, sanitize: true }
  ]

  get items () {
    return this.teamPoints.map((teamPoint, i) => {
      let customerNames = ''
      if (teamPoint.team.customerToTeams.length) {
        teamPoint.team.customerToTeams.forEach((customerToTeam: {customer: User}) => {
          if (customerToTeam.customer) {
            customerNames += `${customerToTeam.customer.firstname} ${customerToTeam.customer.lastname}<br />`
          }
        })
      } else {
        customerNames = '-'
      }

      let vehicleInfo = ''

      teamPoint.team.vehicles.forEach((vehicle: Vehicle) => {
        vehicleInfo += `${vehicle.brand} ${vehicle.type}` + '<br />'
      })

      if (!vehicleInfo) {
        vehicleInfo = '-'
      }

      return {
        ranking: `#${i + 1}`,
        id: '#' + teamPoint.team.number,
        name: sanitizeHtml(teamPoint.team.name),
        points: teamPoint.totalPoints,
        vehicle: sanitizeHtml(vehicleInfo),
        customersName: sanitizeHtml(customerNames)
      }
    })
  }

  mounted () {
    this.rallyRoundId = parseInt(this.$route.params.rallyRoundId)
    this.loadRounds()
  }

  async loadRounds () {
    this.rounds = await RallyRound.getAll({ params: ['admin-permission'] })
  }

  @Watch('rallyRoundId')
  async onRallyRoundIdChange () {
    this.teamPoints = await (await Http.request(`/api/rally-round/${this.rallyRoundId}/top-teams`)).json()
  }
}
